import { Breadcrumb } from "@app/shared/components/Breadcrumb";
import { type GradeCategoryWithLessons } from "@core/grades/types";
import {
  CategoryChapterMap,
  CategoryChildLessons,
  CategoryDetailsEmptyState,
  CategoryDetailsHero,
  CategoryLessonsSection,
} from "../components/CategoryDetails";
import { useCategoryDetailsPage } from "../hooks/use-category-details-page.hook";

type CategoryDetailsPageContentProps = {
  category: GradeCategoryWithLessons;
};

export function CategoryDetailsPageContent({
  category,
}: CategoryDetailsPageContentProps) {
  const page = useCategoryDetailsPage(category);

  return (
    <div className="app-page-canvas min-h-screen bg-gradient-to-b from-gray-50/80 via-white to-white pb-16 dark:from-gray-950 dark:via-gray-950 dark:to-gray-900">
      <div className="container mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
        <div className="mb-5">
          <Breadcrumb items={page.breadcrumbs} />
        </div>

        <CategoryDetailsHero
          category={category}
          childCategoriesCount={page.childCategories.length}
          directLessonsCount={page.directLessons.length}
          totalLessons={page.totalLessons}
        />

        {page.hasContent ? (
          <>
            <CategoryLessonsSection lessons={page.directLessons} />
            <CategoryChapterMap categories={page.childCategories} />
            <CategoryChildLessons
              categories={page.childCategoriesWithLessons}
            />
          </>
        ) : (
          <CategoryDetailsEmptyState category={category} />
        )}
      </div>
    </div>
  );
}
